import { BoxProps } from '@jfs/ui-new'

export const shadowStyle = {
  shadowColor: 'GRAY_SHADOW',
  shadowOffset: {
    width: 1,
    height: 2,
  },
  shadowOpacity: 1,
  shadowRadius: 2,
  elevation: 1,
}

export const styles = {
  container: (color: string, isSmallToast: boolean) =>
    ({
      flexDirection: 'row',
      padding: 16,
      minHeight: 70,
      width: isSmallToast ? '40%' : '100%',
      minWidth: 350,
      bg: color,
      borderRadius: isSmallToast ? 8 : 1,
      alignSelf: 'center',
      ...shadowStyle,
    } as BoxProps),
  iconContainer: {
    justify: 'center',
    paddingRight: 10,
    zIndex: 999,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  descriptionContainer: (isDefault: boolean) =>
    ({
      justify: 'center',
      width: isDefault ? '92%' : '80%',
    } as BoxProps),
}
